module.exports = __webpack_public_path__ + "static/media/PDF-02.9492b592.webp";